import React from 'react'
import {
	Box,
	Typography,
	Button,
	useMediaQuery,
	useTheme
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

// Main SuccessScreen Component
function SuccessScreen({
	onReturnHome,
	merchantName
}) {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('md'))

	return (
		<Box sx={{
			minHeight: '100vh',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px',
			padding: '24px',
			background: 'linear-gradient(180deg, #F7F6F3 37%, #F1E9FC 100%)'
		}}>
			{/* Success Card */}
			<Box sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				gap: '32px',
				padding: isMobile ? '32px 24px' : '16px 24px',
				width: '100%',
				maxWidth: isMobile ? '100%' : '900px',
				minHeight: isMobile ? 'auto' : '774px',
				bgcolor: '#9F7AEA',
				borderRadius: '12px'
			}}>
				{/* Checkmark Icon */}
				<Box sx={{
					width: '64px',
					height: '64px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}>
					<CheckCircleIcon sx={{
						width: '64px',
						height: '64px',
						color: '#FFFFFF'
					}} />
				</Box>

				{/* Success Message */}
				<Typography sx={{
					fontFamily: 'Inter',
					fontWeight: 600,
					fontSize: '24px',
					lineHeight: 1.21,
					color: '#FFFFFF',
					textAlign: 'center'
				}}>
					Your booking request has been submitted!
				</Typography>

				{/* Additional Info */}
				<Typography sx={{
					fontFamily: 'Inter',
					fontWeight: 400,
					fontSize: '16px',
					lineHeight: 1.5,
					color: 'rgba(255, 255, 255, 0.9)',
					textAlign: 'center',
					maxWidth: '400px'
				}}>
					You will receive a confirmation email shortly. The merchant will review and confirm your booking.
				</Typography>

				{/* Return Home Button */}
				<Button
					onClick={onReturnHome}
					sx={{
						py: '12px',
						px: '32px',
						bgcolor: '#E9D8FD',
						border: '1px solid #E9D8FD',
						borderRadius: '9999px',
						color: '#6B46C1',
						fontFamily: 'Inter',
						fontWeight: 600,
						fontSize: '14px',
						lineHeight: 1.21,
						letterSpacing: '-1.79%',
						textTransform: 'none',
						minWidth: '200px',
						'&:hover': {
							bgcolor: '#D6BCFA',
							borderColor: '#D6BCFA'
						}
					}}
				>
					{merchantName ? `Back to ${merchantName}` : 'Back to home'}
				</Button>
			</Box>
		</Box>
	)
}

export default SuccessScreen

